module.exports = __webpack_public_path__ + "img/sparkles-dark.532e71f.svg";